// src/components/GoogleNameModal.js
import React, { useState } from 'react';
import './GoogleNameModal.css';

const GoogleNameModal = ({ 
  currentLanguage, 
  getLocalizedText, 
  googleUser, 
  onSubmit,
  onClose 
}) => {
  const t = (ar, en) => getLocalizedText(ar, en);

  const [firstName, setFirstName] = useState(googleUser?.displayName?.split(' ')[0] || '');
  const [lastName, setLastName] = useState(
    googleUser?.displayName?.split(' ').slice(1).join(' ') || ''
  );
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!firstName.trim() || !lastName.trim()) {
      setError(t('يرجى إدخال الاسم الأول والأخير', 'Please enter first and last name'));
      return;
    }
    onSubmit({ firstName: firstName.trim(), lastName: lastName.trim() });
  };

  return (
    <div className="google-name-modal-overlay">
      <div className={`google-name-modal ${currentLanguage === 'ar' ? 'ar' : 'en'}`}>
        <button className="google-name-close" onClick={onClose}>×</button>

        <div className="google-name-header">
          <img src="/assets/logo.png" alt="ROOMATE" className="modal-logo" />
          <h2>{t('إكمال بيانات الحساب', 'Complete Your Profile')}</h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="name-fields">
            <div className="name-field">
              <label>{t('الاسم الأول', 'First Name')}</label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder={t('الاسم الأول', 'First Name')}
                required
              />
            </div>

            <div className="name-field">
              <label>{t('الاسم الأخير', 'Last Name')}</label>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder={t('الاسم الأخير', 'Last Name')}
                required
              />
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="google-name-submit-btn">
            {t('حفظ ومتابعة', 'Save & Continue')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default GoogleNameModal;